import React from 'react';
import { Link } from 'react-router-dom';
import { useIntl, FormattedMessage, FormattedDate, FormattedTime } from 'react-intl';
import Card from '../common/Card/Card';
import styles from './SubmissionListItem.module.css';
import { FiUser, FiChevronRight } from 'react-icons/fi';

const SubmissionListItem = ({ submission, formId }) => {
    const intl = useIntl();
    const submissionLink = `/form/${formId}/answers/${submission.id}`;

    return (
        <Link to={submissionLink} className={styles.linkWrapper}>
            <Card className={`${styles.submissionCard} ${!submission.is_read && styles.unread}`}>

                <FiUser className={styles.icon} />
                <div className={styles.info}>
                    <h3 className={styles.title}>
                        {/*<FormattedMessage id="submission.item.title" values={{ id: submission.id.toString().substring(0, 8) }} />*/}
                        <FormattedMessage id="submission.item.title" values={{ id: submission.submission_number }} />
                    </h3>
                    <p className={styles.submitter}>
                        <FormattedMessage id="submission.item.submitterId" />
                        {' '}
                        {submission.submitter_id || intl.formatMessage({ id: "submission.item.anonymous" })}
                    </p>
                </div>
                <div className={styles.dateWrapper}>
                    <div className={styles.dateWrapperList}>
                        <span className={styles.date}>
                            <FormattedDate value={submission.submitted_at} />
                        </span>
                        <span className={styles.time}>
                            <FormattedTime value={submission.submitted_at} hour="numeric" minute="numeric" />
                        </span>
                    </div>
                    <FiChevronRight className={styles.chevron} />
                </div>
            </Card>
        </Link>
    );
};
export default SubmissionListItem;
